import { Injectable }    from '@angular/core';
import { Store }         from '@ngrx/store';
import { FileExtension } from '~domain/enums';
import {
  payDocumentType,
  PaymentData,
  RbDocument,
  SimpleDocument,
}                        from '~domain/types';
import * as AppActions   from '../state/app.actions';
import {
  fetchDocumentPaymentData,
  fetchDocumentProcessingData,
}                        from '../state/app.actions';
import * as AppSelectors from '../state/app.selectors';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  documentDownloadingId$ = this.store.select(AppSelectors.selectDocumentDownloadingId);
  selectingDocuments$ = this.store.select(AppSelectors.selectSelectingDocuments);
  toggleDocumentHiddenIsLoadingId$ = this.store.select(AppSelectors.selectToggleDocumentHiddenIsLoadingId);
  toggleDocumentSharedIsLoadingId$ = this.store.select(AppSelectors.selectToggleDocumentSharedIsLoadingId);
  fetchingDocumentPaymentDataId$ = this.store.select(AppSelectors.selectFetchingDocumentPaymentDataId);
  fetchingDocumentAssignmentDataIds$ = this.store.select(AppSelectors.selectFetchingDocumentAssignmentDataIds);
  fetchingDocumentProcessingData$ = this.store.select(AppSelectors.selectFetchingDocumentProcessingData);

  constructor(private readonly store: Store) {
  }

  downloadDocument(name: string, extension: FileExtension, id: string, clientId?: string) {
    this.store.dispatch(AppActions.downloadDocument({ id, clientId, name, extension }));
  }

  startSelectingDocuments() {
    this.store.dispatch(AppActions.startSelectingDocuments());
  }

  stopSelectingDocuments() {
    this.store.dispatch(AppActions.stopSelectingDocuments());
  }

  viewDocument(document: RbDocument) {
    this.store.dispatch(AppActions.fetchViewDocument({ document }));
  }

  renameDocument(document: RbDocument) {
    this.store.dispatch(AppActions.openRenameDocumentDialog({ document }));
  }

  assignDocuments(documents: RbDocument[]) {
    this.store.dispatch(AppActions.fetchDocumentAssignmentData({ documents }));
  }

  setDocumentHidden(hidden: boolean, documentId: string, clientId?: string) {
    this.store.dispatch(AppActions.setDocumentHidden({ hidden, documentId, clientId }));
  }

  setDocumentShared(shared: boolean, documentId: string, clientId?: string) {
    this.store.dispatch(AppActions.setDocumentShared({ shared, documentId, clientId }));
  }

  deleteDocuments(documents: RbDocument[]) {
    this.store.dispatch(AppActions.openDeleteDocumentDialog({ documents }));
  }

  openDocumentPaymentDialog(document: RbDocument | SimpleDocument,
                            reloadAfterSave: boolean,
                            clientId?: string,
                            paymentData?: PaymentData,
                            queuedDocuments?: RbDocument[]) {
    const documentId = document.id;
    const documentType = payDocumentType(document);
    if (documentType) {
      this.store.dispatch(fetchDocumentPaymentData({
        documentId,
        documentName: document.name,
        documentExtension: document.extension,
        documentType,
        clientId,
        paymentData,
        queuedDocuments,
        reloadAfterSave,
      }));
    }
  }

  openDocumentProcessingDialog(document: RbDocument, queuedDocuments: RbDocument[]) {
    this.store.dispatch(fetchDocumentProcessingData({
      document,
      documentType: payDocumentType(document),
      queuedDocuments,
    }));
  }
}
